var _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTitleCreatePlan3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 87,
    viewBox: "0 0 110 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7461 43.5L45.3096 6.58569V80.4144L23.7461 43.5Z",
    fill: "#C4FC3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110 43.5L88.4366 6.58569V80.4144L110 43.5Z",
    fill: "#C4FC3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3096 6.58569H88.4366V80.4144H45.3096V6.58569Z",
    fill: "#C4FC3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 43.5L25.4921 0V87L0 43.5Z",
    fill: "#6A9406"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.968 43.5L76.4762 0V87L101.968 43.5Z",
    fill: "#6A9406"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4921 0H76.4762V87H25.4921V0Z",
    fill: "#6A9406"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.9683,
    cy: 23.2232,
    rx: 13.9683,
    ry: 13.8645,
    fill: "#C4FC3F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6226 47.3496H56.3664C61.6189 47.3496 67.3418 47.5053 67.3418 53.7304C67.3418 57.8545 64.9116 60.8114 59.8158 60.8114C54.7985 60.8114 52.3682 58.3214 51.5843 54.4307L39.1978 57.3098C41.4712 67.1921 49.2324 71.5497 59.1103 71.5497C70.0073 71.5497 79.1012 66.1027 79.1012 55.0532C79.1012 48.6725 75.3382 43.0699 68.6746 42.2139V41.9805C74.7894 40.7355 78.1604 35.9888 78.1604 29.9194C78.1604 19.3367 69.3017 14.5901 59.4239 14.5901C50.0164 14.5901 42.0984 18.2473 39.6681 27.8184L52.6034 30.4641C53.309 27.585 55.8177 25.3284 59.5023 25.3284C63.3436 25.3284 66.4011 27.7406 66.4011 31.0866C66.4011 36.3001 61.7757 37.2339 57.464 37.2339H53.6226V47.3496Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleCreatePlan3);
export default __webpack_public_path__ + "static/media/titleCreatePlan3.ed3ef1d2b88d02dbe59049a77878be18.svg";
export { ForwardRef as ReactComponent };